// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var externalContactContainer = "ExternalContactContainer-module--external-contact-container--3rwGC";